module.exports = __webpack_public_path__ + "img/integralTask_bg1.3627df31.jpg";